const animations = require("../animation.product-finder");

// Run stars animation on hover
$(document).on('mouseenter', '.step__type--stars .step__answer', (e) => {
    const answer = e.currentTarget;
    const answers = $(answer).closest('.step__answers');

    // Set active answer
    $(answers).find('.step__answer').removeClass('active');
    $(answer).addClass('active');

    // Move the line to the current hovered element
    animations.animateStepper(answer);
});

$(document).on('mouseleave', '.step__type--stars .step__answer', (e) => {
    const answer = e.currentTarget;
    const answers = $(answer).closest('.step__answers');

    $(answers).find('.step__answer').removeClass('active');

    animations.animateStepper(0, answers);
});
